module.exports = __webpack_public_path__ + "img/shoe-elements.255d8a86.png";